<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>My Vehicle</h2>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>
        <div v-if="showVehicleForm === true">
          <form action="form" @submit.prevent="saveVehicle">
            <div class="row">
              <div class="col-md-6" style="padding-right: 9px;">
                <input
                  type="text"
                  id="vehicleName"
                  name="vehicleName"
                  placeholder="Name"
                  v-model="vehicleName"
                />
              </div>
              <div class="col-md-6" style="padding-left: 9px;">
                <input
                  type="text"
                  id="dealerPhone"
                  name="dealerPhone"
                  placeholder="Dealer Phone"
                  v-model="dealerPhone"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6" style="padding-right: 9px;">
                <input
                  type="text"
                  id="registrationNumber"
                  name="registrationNumber"
                  placeholder="Registration Number"
                  v-model="registrationNumber"
                />
              </div>
              <div class="col-md-6" style="padding-left: 9px;">
                <input
                  type="text"
                  id="bDownPhone"
                  name="bDownPhone"
                  placeholder="B/down Phone"
                  v-model="bDownPhone"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input
                  type="text"
                  id="oilType"
                  name="oilType"
                  placeholder="Oil Type"
                  v-model="oilType"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6" style="padding-right: 9px;">
                <input
                  type="text"
                  id="typePressureF"
                  name="typePressureF"
                  placeholder="Tyre Pressure F"
                  v-model="tyrePressureF"
                />
              </div>
              <div class="col-md-6" style="padding-left: 9px;">
                <input
                  type="text"
                  id="typePressureR"
                  name="typePressureR"
                  placeholder="Tyre Pressure R"
                  v-model="tyrePressureR"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12" style="padding-right: 15px;">
                <input
                  type="text"
                  id="note"
                  name="note"
                  placeholder="Note"
                  v-model="note"
                />
              </div>
            </div>
            <button
              v-if="isUpdateMyVehicleButtonLoading === true"
              type="submit"
              disabled
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Updating...
            </button>
            <button
              v-if="isUpdateMyVehicleButtonLoading === false"
              type="submit"
            >
              Update
            </button>
          </form>
          <div class="spacer-60"></div>
        </div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import vehicleActions from "@/store/vehicles/actions";
import Cards from "./Cards.vue";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  beforeMount() {
    this.$store.dispatch(vehicleActions.FETCH_VEHICLE);
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
    this.showVehicleForm =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showVehicleForm === true);
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    vehicle: {
      get() {
        return this.$store.state.vehicles.vehicle;
      }
    },
    vehicleName: {
      get() {
        return this.$store.state.vehicles.vehicle?.name;
      },
      set(value) {
        this.$store.commit("updateVehicleNameMutation", value);
      }
    },
    dealerPhone: {
      get() {
        return this.$store.state.vehicles.vehicle?.dealerPhone;
      },
      set(value) {
        this.$store.commit("updateVehicleDealerPhoneMutation", value);
      }
    },
    registrationNumber: {
      get() {
        return this.$store.state.vehicles.vehicle?.registrationNumber;
      },
      set(value) {
        this.$store.commit("updateVehicleRegistrationNumberMutation", value);
      }
    },
    bDownPhone: {
      get() {
        return this.$store.state.vehicles.vehicle?.bDownPhone;
      },
      set(value) {
        this.$store.commit("updateVehicleBDownPhoneMutation", value);
      }
    },
    oilType: {
      get() {
        return this.$store.state.vehicles.vehicle?.oilType;
      },
      set(value) {
        this.$store.commit("updateVehicleOilTypeMutation", value);
      }
    },
    tyrePressureF: {
      get() {
        return this.$store.state.vehicles.vehicle?.tyrePressureF;
      },
      set(value) {
        this.$store.commit("updateVehicleTyrePressureFMutation", value);
      }
    },
    tyrePressureR: {
      get() {
        return this.$store.state.vehicles.vehicle?.tyrePressureR;
      },
      set(value) {
        this.$store.commit("updateVehicleTyrePressureRMutation", value);
      }
    },
    note: {
      get() {
        return this.$store.state.vehicles.vehicle?.note;
      },
      set(value) {
        this.$store.commit("updateVehicleNoteMutation", value);
      }
    },
    isUpdateMyVehicleButtonLoading: {
      get() {
        return this.$store.state.settings.isUpdateMyVehicleButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsUpdateMyVehicleButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    saveVehicle: async function() {
      this.isUpdateMyVehicleButtonLoading = true;
      if (this.vehicle.id !== undefined) {
        await this.$store.dispatch(vehicleActions.UPDATE_VEHICLE, this.vehicle);
      } else {
        await this.$store.dispatch(vehicleActions.CREATE_VEHICLE, this.vehicle);
      }
    }
  }
};
</script>
